import { db, storage } from "../firebase-config";
import { collection, getDocs, query, onSnapshot, doc, setDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

export const getAllProducts = async (organization) => {
  try {
      const productsCollectionRef = collection(db, "organizations", organization, "products");
      const q = query(productsCollectionRef);
      const querySnapshot = await getDocs(q);
      const products = [];
      querySnapshot.forEach((doc) => {
          products.push({ id: doc.id, ...doc.data() });
      });
      return products;
  } catch (error) {
      console.error("Error getting documents: ", error);
      alert(error);
  }
};

//Snapshot Listeners
export const organizationProductSnapshotListener = (organization, onProductUpdate) => {
    const productQuery = query(collection(db, "organizations", organization, "products"))
    const unsubscribe = onSnapshot(productQuery, (querySnapshot) => {
        const productItems = [];
        querySnapshot.forEach((doc) => {
          productItems.push({ id: doc.id, ...doc.data() });
        });
        onProductUpdate(productItems);
    })
    return () => unsubscribe()
}

export const productSnapshotListener = (organization, productId, onProductUpdate) => {
    const productRef = doc(db, 'organizations', organization, 'products', productId);
    const unsubscribe = onSnapshot(productRef, (docSnapshot) => {
        if (docSnapshot.exists()) {
            const product = { id: docSnapshot.id, ...docSnapshot.data() };
            onProductUpdate(product);
        } else {
            onProductUpdate(null);
        }
    })
    return unsubscribe;
  };

  export const uploadProductImageAndReferenceInFirestore = async (organization, itemId, file) => {
    try {
        const fileExtension = file.name.split('.').pop();
        const filePath = `/organizations/${organization}/products/${itemId}/image.${fileExtension}`;
        
        const storageRef = ref(storage, filePath);
        const snapshot = await uploadBytes(storageRef, file);
        const downloadURL = await getDownloadURL(snapshot.ref);

        const productItemDocRef = doc(db, "organizations", organization, "products", itemId);
        
        await setDoc(productItemDocRef, {
            product_image_path: filePath,
            product_image_url: downloadURL
        }, { merge: true });

        return { success: true, error: null };
    } catch (error) {
        console.error("Error uploading product image:", error);
        return { success: false, error: error.message || 'Failed to upload product image' };
    }
};